import TheSpeed from "./speedometer";
import _ from "lodash";
import store from "../../store/index";

export default class OneUpload {
  constructor(opt, callback, callbackType) {
    this.callbackType = callbackType // 回调函数类型
    this.currentSpeed = 0 // 当前速度
    this.loaded = 0 // 已上传大小
    this._loaded = 0 // 已上传大小
    this.theSpeed = new TheSpeed() // 计算速度
    this.part_number = 1 // 当前上传的片
    this.sign_url = '' // 上传接口地址
    this.msgToast = '' // 返回信息提示
    this.md5List=[] //上传每个的md5列表
    this.isFileComplete = false // 文件是否合并
    this.xmlHttp = null // 上传请求实体
    // 新增并行上传相关属性
    // this.parallel = 3 // 并行上传数量，可根据需要调整
    this.upItems = [] // 上传任务分片信息
    this.upRequests = [] // 并行上传的请求对象
    this.abortController = null // 用于取消所有请求
    this.completedParts = 0 // 已完成的分片数量
    // 修改：更准确的上传状态记录
    this.uploadedParts = new Map() // 使用Map记录分片状态：partNumber -> {uploaded: boolean, size: number}
    this.verifiedParts = new Set() // 服务器验证过的分片
    // 严格的分片状态管理
    this.chunkStates = new Map() // 分片状态管理：partNumber -> {status, taskId}
    this.STATUS = {
      PENDING: 'pending',
      UPLOADING: 'uploading',
      COMPLETED: 'completed',
      FAILED: 'failed',
    }

    // 原子操作的分片分配器
    this.nextChunkIndex = 1
    this.chunkAllocationLock = false
    for (let optKey in opt) {
      this[optKey] = opt[optKey]
    }

    if (!this.sizeM1) {
      this.sizeM1 = 2 * 1024 * 1024 // 上传每片大小
    }
    this.part_count = Math.ceil(this.size / this.sizeM1) // 分片片数

    if (callback) {
      this.upCallback = callback // 回调函数
    }
    // 初始化分片信息
    this.initChunkInfo()
  }
  get parallel() {
    let _max = 1
    if (this.$store) {
      let _info = this.$store.state.userInfo || {}
      _max = Number(_info.direct_upload_max_part) || 1
    }
    return _max
  }
  // 原子性地获取下一个未上传的分片
  getNextUnuploadedChunk() {
    if (this.chunkAllocationLock) return null
    this.chunkAllocationLock = true

    try {
      // 从当前索引开始，找到第一个需要上传的分片
      for (let i = this.nextChunkIndex; i <= this.part_count; i++) {
        const state = this.chunkStates.get(i)
        if (!state || state.status === this.STATUS.PENDING || state.status === this.STATUS.FAILED) {
          this.nextChunkIndex = i + 1
          return i
        }
      }
      
      // 如果从当前索引没找到，从头开始找（处理循环分配）
      for (let i = 1; i < this.nextChunkIndex; i++) {
        const state = this.chunkStates.get(i)
        if (!state || state.status === this.STATUS.PENDING || state.status === this.STATUS.FAILED) {
          this.nextChunkIndex = i + 1
          return i
        }
      }
      
      return null // 所有分片都已处理
    } finally {
      this.chunkAllocationLock = false
    }
  }
  // 改进的初始化方法
  initChunkInfo() {
    this.upItems = []
    this.chunkStates.clear()
    this.nextChunkIndex = 1

    // 初始化所有分片状态
    for (let i = 1; i <= this.part_count; i++) {
      // 检查是否已经上传过
      const wasUploaded =
        this.uploadedParts.get(i) && this.uploadedParts.get(i).uploaded
      this.chunkStates.set(i, {
        status: wasUploaded ? this.STATUS.COMPLETED : this.STATUS.PENDING,
        taskId: null,
      })
    }

    // 创建并行任务（不再按范围分配，使用统一的分配器）
    for (let i = 0; i < this.parallel; i++) {
      this.upItems.push({
        id: i,
        current: 0,
      })
    }

    // 重新计算已完成数量
    this.completedParts = this.getCompletedPartsCount()
  }
  // 获取文件后缀
  getExtension() {
    let _name = this.name || ''
    return _name.substring(_name.lastIndexOf(".")+1)
  }

  // 已上传大小
  sizeUploaded() {
    if (this.size < this.loaded) return this.size
    return this.loaded
  }

  // 上传还剩余多少时间
  timeRemaining() {
    if (this.size < this.loaded) return 0
    return this.currentSpeed==0 ? 0 : Math.floor((this.size - this.loaded) / this.currentSpeed)
  }

  // 上传进度
  progress() {
    if (this.size <= 0) return 0
    const progress = Math.min(this.loaded / this.size, 1)
    return Number(progress.toFixed(4))
  }

  // 取消上传任务
  cancelTask() {
    if (this.task_id) {
      let _form = new FormData()
      _form.append('task_id', this.task_id)
      fetch(this.cancel_url, {
        method: 'post',
        body: _form
      })
        .then((response) => response.json())
        .then(() => {}).catch(() => {})
    }
  }

  // 获取上传链接地址
  getSignUrl() {
    let _form = new FormData()
    _form.append('task_id', this.task_id)
    _form.append('m', this.md5List[this.part_number-1].md5)
    _form.append('part_number', this.part_number)
    fetch(this.upload_part_url, {
      method: 'post',
      body: _form
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 1) {
          this.sign_url = res.data.sign_url
          this.uploadRequest()
        } else {
          this.fail(res.msg)
        }
      }).catch(() => {
        this.fail()
      })
  }
  // 获取上传链接地址（并行版本）
  async getSignUrlNew(partNumber) {
    let _form = new FormData()
    _form.append('task_id', this.task_id)
    _form.append('m', this.md5List[partNumber - 1].md5)
    _form.append('part_number', partNumber)

    try {
      const response = await fetch(this.upload_part_url, {
        method: 'post',
        body: _form,
      })
      const res = await response.json()
      if (res.status == 1) {
        return res.data.sign_url
      } else {
        this.fail(res.msg)
      }
    } catch (error) {
      this.fail()
      throw error
    }
  }
  // 严格的上传单个分片方法
  async uploadChunk(taskId, partNumber) {
    // 双重检查：确保分片确实需要上传
    const currentState = this.chunkStates.get(partNumber)
    if (currentState && currentState.status === this.STATUS.COMPLETED) {
      // console.log(`分片 ${partNumber} 已上传完成，跳过`)
      return Promise.resolve(partNumber)
    }

    if (this.fileStatus !== 1) {
      return Promise.reject('upload_cancelled')
    }

    try {
      const signUrl = await this.getSignUrlNew(partNumber)

      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()
        // 使用partNumber作为key，避免任务ID冲突
        this.upRequests[partNumber] = xhr

        const chunkBlob = this.getChunkBlob(partNumber)
        let startProgress = 0

        xhr.upload.onprogress = ev => {
          if (ev.lengthComputable) {
            const transfer = ev.loaded - startProgress
            this.theSpeed.spLength += transfer
            this._loaded += transfer
            startProgress = ev.loaded
          }
        }

        xhr.onreadystatechange = () => {
          if (xhr.readyState == 4) {
            delete this.upRequests[partNumber]
            if (xhr.status == 200) {
              // 严格标记分片为已完成
              this.chunkStates.set(partNumber, {
                status: this.STATUS.COMPLETED,
                taskId: taskId,
                completedTime: Date.now(),
              })
              this.verifiedParts.add(partNumber)
              this.completedParts = this.getCompletedPartsCount() // 重新计算

              // console.log(
              //   `分片 ${partNumber} 上传成功，已完成 ${this.completedParts}/${this.part_count}`
              // )
              resolve(partNumber)
            } else {
              // 上传失败，重置状态
              this.chunkStates.set(partNumber, {
                status: this.STATUS.FAILED,
                taskId: null,
              })
              this.verifiedParts.delete(partNumber)
              this.completedParts = this.getCompletedPartsCount() // 重新计算

              if (xhr.status !== 0 || this.fileStatus !== 2) {
                reject(new Error(`HTTP ${xhr.status}: ${xhr.statusText}`))
              }
            }
          }
        }

        xhr.onerror = err => {
          delete this.upRequests[partNumber]
          this.chunkStates.set(partNumber, {
            status: this.STATUS.FAILED,
            taskId: null,
          })
          this.verifiedParts.delete(partNumber)
          this.completedParts = this.getCompletedPartsCount() // 重新计算
          reject(err)
        }

        xhr.open('PUT', signUrl, true)
        xhr.setRequestHeader('Content-Type', 'text/plain')
        xhr.send(chunkBlob)
      })
    } catch (error) {
      this.chunkStates.set(partNumber, {
        status: this.STATUS.FAILED,
        taskId: null,
      })
      this.verifiedParts.delete(partNumber)
      this.completedParts = this.getCompletedPartsCount() // 重新计算
      throw error
    }
  }
  // 辅助方法：获取分片大小
  getChunkSize(partNumber) {
    if (partNumber == this.part_count) {
      return this.size - (partNumber - 1) * this.sizeM1
    }
    return this.sizeM1
  }

  // 辅助方法：获取分片数据
  getChunkBlob(partNumber) {
    const blobSlice =
      File.prototype.slice ||
      File.prototype.mozSlice ||
      File.prototype.webkitSlice
    if (partNumber == this.part_count) {
      return blobSlice.call(
        this.file,
        (partNumber - 1) * this.sizeM1,
        this.size
      )
    }
    return blobSlice.call(
      this.file,
      (partNumber - 1) * this.sizeM1,
      partNumber * this.sizeM1
    )
  }
  // 执行上传任务的方法
  async executeUploadTask(task) {
    const { id } = task

    while (this.fileStatus === 1) {
      // 原子性地获取下一个分片
      const partNumber = this.getNextUnuploadedChunk()

      if (!partNumber) {
        // 没有更多分片需要上传
        break
      }

      // 检查分片是否已经在其他任务中上传完成
      const existingState = this.chunkStates.get(partNumber)
      if (existingState && existingState.status === this.STATUS.COMPLETED) {
        // console.log(`分片 ${partNumber} 已由其他任务完成，跳过`)
        continue
      }

      // 标记分片为上传中
      this.chunkStates.set(partNumber, {
        status: this.STATUS.UPLOADING,
        taskId: id,
        startTime: Date.now(),
      })

      try {
        await this.uploadChunk(id, partNumber)

        // 更新任务当前进度
        task.current = partNumber

        // 发送进度回调
        if (this.upCallback && this.callbackType !== 'async') {
          this._callback('progress', {
            progress: this.progress(),
            completedParts: this.getCompletedPartsCount(),
            totalParts: this.part_count,
          })
        }

        // 检查是否完成所有分片上传
        if (this.isAllPartsUploaded()) {
          // console.log('检测到所有分片上传完成')
          break
        }
      } catch (error) {
        // 上传失败，重置分片状态
        this.chunkStates.set(partNumber, {
          status: this.STATUS.FAILED,
          taskId: null,
          error: error.message,
        })

        if (error !== 'upload_cancelled') {
          // console.log(`分片 ${partNumber} 上传失败:`, error)
          // 可以选择重试，这里直接抛出错误停止上传
          throw error
        }
        break
      }
    }
  }

  // 准确计算已完成分片数量
  getCompletedPartsCount() {
    let count = 0
    for (let [partNumber, state] of this.chunkStates) {
      if (state.status === this.STATUS.COMPLETED) {
        count++
      }
    }
    return count
  }

  // 严格检查是否所有分片都已上传
  isAllPartsUploaded() {
    const count = this.getCompletedPartsCount()
    if (count >= this.part_count) {
      // 详细验证每个分片状态
      for (let i = 1; i <= this.part_count; i++) {
        const state = this.chunkStates.get(i)
        if (!state || state.status !== this.STATUS.COMPLETED) {
          // console.logo(`分片 ${i} 未完成，状态: ${state ? state.status : 'undefined'}`)
          return false
        }
      }
      return true
    }
    return false
  }
  // 开始并行上传
  async startParallelUpload() {
    this.abortController = new AbortController()
    this._loaded = this.loaded // 重新计算已上传大小

    // 初始化速度计算
    this.theSpeed.initSpeed(_speed => {
      this.currentSpeed = _speed
      this.loaded = this._loaded
      if (this.upCallback && this.callbackType !== 'async') {
        this._callback('progress', {
          progress: this.progress(),
          completedParts: this.getCompletedPartsCount(),
          totalParts: this.part_count,
        })
      }
    })

    // 创建并行上传任务
    const uploadPromises = this.upItems.map(task =>
      this.executeUploadTask(task)
    )

    try {
      await Promise.all(uploadPromises)

      // 所有分片上传完成，检查是否全部成功
      if (this.isAllPartsUploaded()) {
        // console.log('所有分片上传完成，开始合并')
        await this.completeUpload()
      } else {
        // 部分失败，但用户没有主动暂停/取消
        // console.log('部分分片上传失败')
      }
    } catch (error) {
      this.fail()
    }
  }
  // 计算当前已上传大小
  calculateCurrentLoaded() {
    let total = 0
    for (let [partNumber, info] of this.uploadedParts) {
      if (info.uploaded) {
        total += info.size
      }
    }
    // 确保计算值不超过文件总大小
    return Math.min(total, this.size)
  }
  // 合并上传分片
  completeUpload() {
    let _form = new FormData()
    _form.append('task_id', this.task_id)
    fetch(this.merge_part_url, {
      method: 'post',
      body: _form
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 1) {
          this.success(res)
        } else {
          this.fail(res.msg)
        }
      }).catch(() => {
      this.fail()
    })
  }

  // 上传请求
  uploadRequest() {
    let _xmlHttp
    if (window.ActiveXObject) {
      _xmlHttp = new ActiveXObject("Microsoft.XMLHTTP")
    } else if (window.XMLHttpRequest) {
      _xmlHttp = new XMLHttpRequest()
    }
    this.xmlHttp = _xmlHttp
    if (_xmlHttp != null) {
      _xmlHttp.open("put", this.sign_url, true);
      _xmlHttp.responseType = 'document'; //关键
      _xmlHttp.setRequestHeader("content-type", "text/plain")
      let _blob
      let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
      if (this.part_number === this.part_count) {
        _blob = blobSlice.call(this.file, (this.part_number - 1) * this.sizeM1, this.size)
      } else {
        _blob = blobSlice.call(this.file, (this.part_number - 1) * this.sizeM1, this.part_number * this.sizeM1)
      }
      let _start = 0
      _xmlHttp.upload.onprogress = (ev) => {
        let transfer = ev.loaded - _start
        this.theSpeed.spLength += transfer
        this._loaded += transfer
        _start = ev.loaded
      }
      _xmlHttp.onreadystatechange = () => {
        if (_xmlHttp.readyState == 4) {
          if (_xmlHttp.status == 200) {
            this.part_number++
            if (this.part_number > this.part_count) {
              this.completeUpload()
            } else if (this.fileStatus == 1) {
              this.getSignUrl()
            }
          } else {
            if (_xmlHttp.status !== 0 || this.fileStatus !== 2) {
              this.fail()
            }
          }
        }
      }
      _xmlHttp.onerror = (err) => {
        this.fail(err.toString())
      }
      _xmlHttp.send(_blob);
    }
  }

  // 恢复上传
  resume() {
    if (this.isAllPartsUploaded()) {
      // console.log('所有分片已完成，无需恢复上传')
      this.completeUpload()
      return
    }
    this.fileStatus = 1
    // 重置分片分配器，从第一个未完成的分片开始
    this.nextChunkIndex = this.findFirstUncompletedChunk()

    // console.log(
    //   `恢复上传，从分片 ${
    //     this.nextChunkIndex
    //   } 开始，当前进度: ${this.getCompletedPartsCount()}/${this.part_count}`
    // )
    this.startParallelUpload()
  }
  //辅助方法：找到第一个未完成的分片
  findFirstUncompletedChunk() {
    for (let i = 1; i <= this.part_count; i++) {
      const state = this.chunkStates.get(i)
      if (!state || state.status !== this.STATUS.COMPLETED) {
        return i
      }
    }
    return this.part_count + 1 // 所有分片都已完成
  }
  // 暂停上传
  pause() {
    this.fileStatus = 2
    this.theSpeed.clearSpeed()

    // 取消所有进行中的请求
    Object.keys(this.upRequests).forEach(partNumber => {
      const xhr = this.upRequests[partNumber]
      if (xhr && xhr.readyState !== 4) {
        xhr.abort()
        // 重置正在上传的分片状态
        const state = this.chunkStates.get(Number(partNumber))
        if (state && state.status === this.STATUS.UPLOADING) {
          this.chunkStates.set(Number(partNumber), {
            status: this.STATUS.PENDING,
            taskId: null,
          })
        }
      }
    })
    this.upRequests = {}

    // console.log(
    //   `暂停上传，已完成 ${this.getCompletedPartsCount()}/${
    //     this.part_count
    //   } 个分片`
    // )
  }

  // 取消上传
  cancel() {
    if (this.xmlHttp) {
      this.xmlHttp.abort()
      this.xmlHttp = null
    }
    this.theSpeed.clearSpeed()
    if (this.fileStatus === 1 || this.fileStatus === 2) {
      this.cancelTask()
    }
  }

  // 重新上传
  retry() {
    this.resume()
  }

  // 上传失败
  fail(msg) {
    this.theSpeed.clearSpeed()
    this.fileStatus = 3
    this.msgToast = msg || ''
    this._callback('fail', { msg })
  }
  // 上传成功
  success(res) {
    this.theSpeed.clearSpeed()
    this.fileStatus = 4
    this.isFileComplete = true
    if (this.$store) {
        getfiles()
    }
    this._callback('success', res)
  }

  // 回调函数
  _callback(act, args) {
    if (this.upCallback) {
      let msg = (args && args.msg) || ''
      this.upCallback({
        action: act,
        res: args,
        msg,
        id: this.id,
        progress: this.progress(),
        speed: this.currentSpeed,
      })
    }
  }
}
const getfiles = _.throttle(
  () => {
    store.commit("getfiles");
  },
  3000,
  {
    leading: true,
    trailing: false,
  }
);

